module.exports = __webpack_public_path__ + "img/course.d03caf50.svg";